/* eslint-disable no-param-reassign,no-console,max-len */
import axios from 'axios';

import Core6Config from '../core6/Core6Config';
import Core6DraggerCommon from './Core6DraggerCommon';
import Core6PositionedComponentDragger from './Core6PositionedComponentDragger';
import Core6RowGUIUpdater from "../core6/Core6RowGUIUpdater";
import Core6Utilities from "../core6/Core6Utilities";
import Core6PagedSlider from "../core6/Core6PagedSlider";
import Core6Component from "../core6/Core6Component";

export default class Core6BlockDragger {
  static init() {
    //console.log('init blocks');
    Core6BlockDragger.initDraggableBlocks();
    Core6BlockDragger.initBlockDropzoneOrdering();
  }

  static initDraggableBlocks() {
    const draggableBlocks = document.querySelectorAll('#srcDragDropzones > li');
    for (let i = 0, len = draggableBlocks.length; i < len; i += 1) {
      const draggableBlock = draggableBlocks[i];
      draggableBlock.setAttribute('draggable', 'true');
      draggableBlock.removeEventListener('dragstart', Core6BlockDragger.dragstartBlockHandler);
      draggableBlock.addEventListener('dragstart', Core6BlockDragger.dragstartBlockHandler);
      draggableBlock.removeEventListener('dragend', Core6BlockDragger.dragendBlockHandler);
      draggableBlock.addEventListener('dragend', Core6BlockDragger.dragendBlockHandler);
    }
  }

  static initBlockDropareas() {
    const previewFrame = document.querySelector('#previewframe').contentWindow;
    const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const dropareas = dropzoneContainer.querySelectorAll('.droparea');
    for (let i = 0, len = dropareas.length; i < len; i += 1) {
      const droparea = dropareas[i];
      droparea.removeEventListener('drop', Core6BlockDragger.dropBlockHandler);
      droparea.removeEventListener('dragover', Core6BlockDragger.dragoverBlockHandler);
      droparea.removeEventListener('dragleave', Core6BlockDragger.dragleaveBlockHandler);
      droparea.addEventListener('drop', Core6BlockDragger.dropBlockHandler);
      droparea.addEventListener('dragover', Core6BlockDragger.dragoverBlockHandler);
      droparea.addEventListener('dragleave', Core6BlockDragger.dragleaveBlockHandler);
    }
  }

  static initBlockDropzoneOrdering() {
    const previewFrame = document.querySelector('#previewframe').contentWindow;
    const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const dropzones = dropzoneContainer.querySelectorAll('.dropzone');
    for (let i = 0, len = dropzones.length; i < len; i += 1) {
      const dropzone = dropzones[i];
      dropzone.setAttribute('data-dz-index', i);
    }
  }

  static addBlockDropareas() {
    //console.log('create drop areas');
    const previewFrame = document.querySelector('#previewframe').contentWindow;
    const dropzoneContainer = previewFrame.document.body.querySelector('.page');
    const dropzones = dropzoneContainer.querySelectorAll('.core6-mainrow-container:not(.isTemplate)');

    //console.log(dropzoneContainer);

    if (dropzones.length === 0) {
      const dropAreaTemplateBefore = Core6DraggerCommon.htmlToElement(Core6BlockDragger.getBlockDropAreaTemplate(0));
      dropzoneContainer.appendChild(dropAreaTemplateBefore);
    } else {
      for (let i = 0, len = dropzones.length; i < len; i += 1) {
        //console.log(`create drop area: ${i}`);
        const dropzone = dropzones[i];

        const dropAreaTemplateBefore = Core6DraggerCommon.htmlToElement(Core6BlockDragger.getBlockDropAreaTemplate(i));
        dropzoneContainer.insertBefore(dropAreaTemplateBefore, dropzone);

        const nextDZ = dropzone.nextElementSibling;
        if (nextDZ !== null) {
          const dropAreaTemplateAfter = Core6DraggerCommon.htmlToElement(Core6BlockDragger.getBlockDropAreaTemplate(i));
          dropzoneContainer.insertBefore(dropAreaTemplateAfter, nextDZ);
        } else {
          const dropAreaTemplateAfter1 = Core6DraggerCommon.htmlToElement(Core6BlockDragger.getBlockDropAreaTemplate(i));
          dropzoneContainer.appendChild(dropAreaTemplateAfter1);
        }
      }
    }
  }

  static dragstartBlockHandler(ev) {
    //console.log('DragStart Block');
    ev.dataTransfer.setData('text/plain', ev.target.getAttribute('data-block-type'));
    ev.dataTransfer.setData('text/html', ev.target.outerHTML);

    // move, copy or link
    ev.dataTransfer.dropEffect = 'copy';
    ev.target.style.opacity = 0.5;
    ev.target.style.zIndex = 9999;
    ev.target.classList.add('isDraggingMe');

    const dragIcon = document.createElement('img');
    dragIcon.src = ev.target.querySelector('img').getAttribute('src');
    dragIcon.width = 100;
    ev.dataTransfer.setDragImage(dragIcon, -10, -10);

    /* var img = new Image();
    img.src = 'img/components/article.jpg';
    ev.dataTransfer.setDragImage(img, 20, 20); */
    setTimeout(() => {
      Core6BlockDragger.addBlockDropareas();
      Core6BlockDragger.initBlockDropareas();
    }, 100);
  }

  static dragoverBlockHandler(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = 'copy';
    ev.target.classList.add('over');
  }

  static dragleaveBlockHandler(ev) {
    ev.preventDefault();
    ev.target.classList.remove('over');
  }

  static dropBlockHandler(ev) {
    ev.preventDefault();
    //console.log(ev);
    ev.target.classList.remove('droparea');

    const {target} = ev;
    const blockType = ev.dataTransfer.getData('text');
    const pageId = document.getElementById('page_id').value;

    let ordering = 0;
    if (target.previousElementSibling) {
      ordering = (target.previousElementSibling.getAttribute('data-row-index') * 1) + 1;
    }
    Core6BlockDragger.addBlock(target, blockType, pageId, ordering);
  }

  static addBlock(target, blockType, pageId, ordering) {
    const config = Core6Config.getAjaxConfig();
    axios.get(`/api/blocks/add/${blockType}/${pageId}/${ordering}`, config)
      .then((res) => {
        target.outerHTML = res.data.block_html;
        Core6Utilities.refreshCSS();
        Core6BlockDragger.saveBlockOrdering();
        Core6Utilities.refreshDialogs();
        /*const dialogs = document.createElement('div');
        dialogs.innerHTML = res.data.block_dialogs;
        document.querySelector('body').appendChild(dialogs);
        Core6Utilities.refreshCSS();
        Core6BlockDragger.saveBlockOrdering();


        setTimeout(Core6Component.initFeatureAndButtonUrls(), 100);
        setTimeout(Core6Utilities.initICheck(), 100);
        setTimeout(Core6Utilities.initDialogTabs(), 100);
        setTimeout(Core6PagedSlider.disableNewPagedSlidersIfNeeded(), 100);

        Core6Utilities.getElement('.core_loading_anim_container').style.display = 'none';*/
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static saveBlockOrdering() {
    const dropzones = Core6Utilities.getElementAll('.core6-mainrow-container:not(.isTemplate)');
    console.log(dropzones);

    const dzToUpdate = [];
    for (let i = 0, len = dropzones.length; i < len; i += 1) {
      const currDz = dropzones[i];
      currDz.setAttribute('data-row-index', i);
      if (currDz.querySelector('.new_index') !== null) {
        currDz.querySelector('.new_index').innerHTML = i;
      }
      currDz.querySelector('[data-core6-ordering]').innerHTML = i;
      dzToUpdate.push({row_id: currDz.getAttribute('data-row-id'), ordering: i});
    }

    const formData = new FormData();
    formData.append('json', JSON.stringify(dzToUpdate));

    const config = Core6Config.getAjaxConfig();

    axios.post('/api/blocks/reorder', formData, config)
      .then(() => {
        Core6DraggerCommon.removeExcessDropareas();
        Core6DraggerCommon.removeDropareas('.component_droparea');

        Core6BlockDragger.initDraggableBlocks();
        // TODO: refactor
        Core6PositionedComponentDragger.initDraggablePositionedComponents();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static getBlockDropAreaTemplate() {
    return "<div class='droparea core6_drop_dropzone_here'></div>";
  }

  static dragendBlockHandler(ev) {

    const previewFrame = document.querySelector('#previewframe').contentWindow;
    const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const draggedBlocks = dropzoneContainer.querySelectorAll('.isDraggingMe');

    ev.target.style.opacity = 1;
    for (let i = 0, len = draggedBlocks.length; i < len; i += 1) {
      const draggedBlock = draggedBlocks[i];
      draggedBlock.classList.remove('isDraggingMe');
    }

    Core6DraggerCommon.removeDropareas('.droparea');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6_dragger/Core6BlockDragger.js